export default "__VITE_ASSET__a881b63b__"